import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { EnvironmentConfiguration } from 'app/environment/services/environment.configuration';
import { OnyxEvent } from '../models/event';
import { PartyType } from '../models/party-type';

@Component({
  selector: 'pioneer-child-contact-form',
  templateUrl: './child-contact-form.component.html'
})
export class ChildContactFormComponent implements OnInit, OnChanges {

  @Input('partyType')
  public partyType: PartyType;

  @Input('contactReferenceNumberTitle')
  public contactReferenceNumberTitle: String;

  @Input('contactForm')
  public contactForm: FormGroup;

  public onyxEvent: OnyxEvent;

  @Input('event')
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  @Input()
  public isReadOnly = true;

  @Input()
  public showLongLabels = false;

  @Input()
  public showSubscriberBadge = false;

  @Input()
  public clientContactEditable = true;

  @Input()
  public canEditVendorCommRate = true;

  @Input()
  public inputEmail: string;

  @Output()
  public outputEmail: EventEmitter<string> = new EventEmitter<string>();

  constructor(private environment: EnvironmentConfiguration) {
  }

  public ngOnInit() {

    if (this.emailValidation()) {
      this.contactForm.get('contact').get('email').valueChanges.subscribe(value => {
        if (this.contactForm && this.contactForm.get('partyType') && this.contactForm.get('partyType').value === PartyType.PROPERTY) {
          this.outputEmail.emit(value);
          this.checkDuplicatedEmailError(value);
        }
      });
    }
    if (this.contactForm.get('commissionRoomPercentage') !== null && this.contactForm.get('commissionRoomPercentage') !== undefined ) {
      this.contactForm.get('commissionRoomPercentage').setValidators(Validators.required);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.emailValidation() && changes.inputEmail && this.contactForm) {
      this.checkDuplicatedEmailError(this.contactForm.get('contact').get('email').value);
    }

    if (!changes[ 'event' ]) {
      return;
    }
  }

  private checkDuplicatedEmailError(formValue) {
    if (formValue && this.inputEmail && formValue.toLowerCase() === this.inputEmail.toLowerCase()) {
      this.contactForm.get('contact').get('email').setErrors({'email_contact_property_agency_same': true});
    } else {
      if (this.contactForm && this.contactForm.get('contact').get('email').errors
          && this.contactForm.get('contact').get('email').errors['email_contact_property_agency_same']) {
        this.contactForm.get('contact').get('email').setErrors(null);
      }
    }
  }

  public emailValidation(): boolean {
    return this.environment.emailValidation;
  }

  public getReadOnly() {
    if (this.partyType === PartyType.CLIENT) {
      return this.isReadOnly || !this.clientContactEditable;
    } else {
      return this.isReadOnly;
    }
  }

  public getReadOnlyClient() {
    if (this.partyType === PartyType.CLIENT) {
      return this.isReadOnly || !this.clientContactEditable;
    } else {
      return true;
    }
  }

  public get commRetention(): boolean {
    return this.contactForm.get('commRetention').value;
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/child-contact-form/child-contact-form.component.ts